import type { AxiosRequestConfig, Method } from 'axios'
import { getCurrentLocaleTransferCode, isToTransfer } from '@user-center/utils/i18n.ts'
import { storeData } from '@user-center/utils/localService'
import request from '@user-center/utils/request'
import setUrl from '@user-center/utils/setUrl'
import { queryUserSubAccountRelation } from './user'

const BASEURL = 'http://127.0.0.1:38080'
// 运单号导入模板
export const fetchTemplateDown = '/file/file/common/down'
// 会员管理导入模板
export const VIPmanagementImportTemplate = '/member/download/uploadTemplate'
// 代客下单 =》 导入模板下载
export const valetOrderTemplateApi = '/file/down'
export const renderListPage = {
  // 查询页 下拉
  url: '/portal/user/renderListPage', // 配置url
  method: 'post', // 配置请求方式
}

const WAREHOUSE_LIST_CACHE_TTL = 5 * 60 * 1000
const warehouseListPendingMap = new Map<string, Promise<unknown>>()
const warehouseListResponseCache = new Map<string, { expireAt: number, response: any }>()

export const renderEditPage = {
  // 更新页 下拉
  url: '/portal/user/renderEditPage', // 配置url
  method: 'post', // 配置请求方式
}
export const getRoleMenuList = {
  // 角色菜单查询
  url: '/portal/role/getRoleMenuList?transferlocate=true', // 配置url
  method: 'post', // 配置请求方式
}
export const getBusinessUserList = {
  // 业务关联用户查询

  url: '/portal/user/getBusinessUserList', // 配置url
  method: 'post', // 配置请求方式
}

export const uploadFile = {
  // 公用文件上传

  url: '/portal/fileTransport/uploadFile', // 配置url
  method: 'post', // 配置请求方式
}

export const downloadFile = {
  // 公用文件下载
  url: '/portal/fileTransport/downloadFile', // 配置url
  method: 'post', // 配置请求方式
}

export function uploadSysFile(formData: any, config = {}): Promise<unknown> {
  return request({
    // url: '/routes',
    // method: 'get'

    url: uploadFile.url,
    method: uploadFile.method as Method,
    data: formData,
    timeout: 45000000,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  })
}
export function makeRequest(
  config: AxiosRequestConfig,
  data: any,
): Promise<unknown> {
  return request({
    ...config,
    url: config.url,
    method: config.method,
    data,
  })
}

export function getOssToken(): Promise<unknown> {
  return request({
    baseURL: setUrl().replace('/mall', ''),
    url: '/basic/aliyun/getToken',
    method: 'get',
  })
}
// 依据当前，前端域名获取展示店铺信息
export function queryDealerShop(data: any): Promise<unknown> {
  return request({
    url: '/admin/dealerShop/queryDealerShop?transferlocate=true',
    // baseURL: "https://api-tmall-test.omszt.com/platform/",
    method: 'POST',
    params: data,
    data,
  })
}

// 依据当前，前端shopId域名获取关联的域名
export function querySiteIdentityByShopId(data: any): Promise<unknown> {
  return request({
    url: `/admin/dealerShop/querySiteIdentityByShopId?shopId=${data.shopId}`,
    method: 'POST',
    data,
  })
}

export function getMemberPackageList(data: any): Promise<unknown> {
  return request({
    url: '/member-package/query/page-list', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

export function getMemberPackageDetail(data: any): Promise<unknown> {
  return request({
    url: '/member-package/query',
    method: 'get',
    params: data,
  })
}

export function updateMemberPackageItem(data: any): Promise<unknown> {
  return request({
    url: '/member-package/update/item',
    method: 'post',
    data,
  })
}

export function getMemberOrderList(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrdersOnPage', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

function createJyUserOrderH5TransferConfig() {
  return isToTransfer()
    ? {
        language: getCurrentLocaleTransferCode(),
        setPath: 'null',
        transferKeysConfig: JSON.stringify([
          ['data', 'list', 'cargoType'],
          ['data', 'list', 'warehouseName'],
          ['data', 'list', 'freightType'],
          ['data', 'list', 'logisticsName'],
          ['data', 'list', 'itemName'],
          ['data', 'list', 'lastTrajectoryStatus'],
          ['data', 'list', 'lastTrajectoryDesc'],
        ]),
      }
    : undefined
}

export function getMemberOrderListH5(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrdersOnPageByH5', // 配置url
    method: 'post', // 配置请求方式
    data: {
      ...data,
      ___transferConfig: createJyUserOrderH5TransferConfig(),
    },
  })
}

export function queryMemberOrdersOnPageByH5(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrdersOnPageByH5?list=true',
    method: 'post',
    data: {
      ...data,
      ___transferConfig: createJyUserOrderH5TransferConfig(),
    },
  })
}

export function queryMemberOrderStatusStatisticsByH5(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrderStatusStatisticsByH5?hiddenErrTip=1',
    method: 'post',
    data: {
      ...data,
    },
  })
}

export function getParcelOrderDetail(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrderById?untransfer=true',
    method: 'post',
    data: { ...data },
  })
}

export function queryParcelOrderSnapshotByOrderCode(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/querySnapshotByOrderCode?untransfer=true',
    method: 'post',
    data: { ...data },
  })
}

export function queryParcelDestCountryConfig(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryDestCountryConfig',
    method: 'post',
    data: { ...data },
  })
}

export function queryParcelOrderLine(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryOrderLine',
    method: 'post',
    data: { ...data },
  })
}

export function getParcelPackageImagePaths(data: any): Promise<unknown> {
  return request({
    url: '../platform/member-package/getImagePaths?untransfer=true',
    method: 'post',
    data: { ...data },
  })
}

export function getStorageOfParcelImg(data: any): Promise<unknown> {
  const {
    firstWaybillNo,
    companyCode = '',
    warehouseCode = '',
  } = data || {}

  return request({
    url: `/member-package/queryImages?firstWaybillNo=${firstWaybillNo || ''}&companyCode=${companyCode}&warehouseCode=${warehouseCode}`,
    method: 'post',
  })
}

export function confirmParcelOrderReceive(data: any): Promise<unknown> {
  return request({
    url: '/admin/mallOrder/confirmReceive',
    method: 'post',
    data: { ...data },
  })
}

export function finishParcelOrder(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/finishOrder',
    method: 'post',
    data: { ...data },
  })
}

export function getMemberPackageImage(data: any): Promise<unknown> {
  return request({
    url: '/member-package/queryImages', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
    params: data,
  })
}
export function batchUpdatePackageItems(data: any): Promise<unknown> {
  return request({
    url: '/member-package/batchUpdate/item', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}
export function queryPackageStats(data: any): Promise<unknown> {
  return request({
    url: '/member-package/query/page-list/stats', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

export function queryPackagePoStats(data: any): Promise<unknown> {
  return request({
    url: '/member-package/query/page-list-po/stats', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

export function cancelPackage(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/cancel', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 获取支付状态
export function getOrderStatusList(): Promise<unknown> {
  return request({
    url: '/jyOrder/getOrderStatusList',
    method: 'get',
  })
}
// 获取包裹状态
export function getPackageStatusList(): Promise<unknown> {
  return request({
    url: '/member-package/query/status/list',
    method: 'get',
  })
}
// 获取动态标记
export function getDynamicFlaglist(): Promise<unknown> {
  return request({
    url: '/member-package/query/dynamicFlag/list', // 配置url
    method: 'get', // 配置请求方式
  })
}
// 跟新登录账号密码
export function UpLoginPassword(data: any): Promise<unknown> {
  return request({
    url: '/portal/user/pwd/modify',
    method: 'POST',
    data,
  })
}
// 首次修改密码
export function firstUpdatePassword(data: any): Promise<unknown> {
  return request({
    url: '/portal/user/pwd/firstModify',
    method: 'POST',
    data,
  })
}

// 跟新登录账号密码
export function UpSubLoginPassword(data: any): Promise<unknown> {
  return request({
    url: '/portal/subUser/pwd/modify',
    method: 'POST',
    data,
  })
}
// 获取货物类型
export function searchCustomsType(): Promise<unknown> {
  return request({
    url: '/common/searchCustomsType',
    method: 'POST',
  })
}
// 获取仓库
export function fetchUserWarehouse(): Promise<unknown> {
  return request({
    url: '/common/searchUserWarehouse',
    method: 'get',
  })
}
// 预报订单 获取仓库
export function getForecastWarehouse(data?: any): Promise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  const warehouseType = typeof data?.warehouseType !== 'undefined' ? data?.warehouseType : '0'
  if (isSubAccount) {
    return queryUserSubAccountRelation({
      param: {
        relationType: '2',
      },
    }).then((res: any) => {
      return res.data?.dataList || []
    }).then((res: any) => {
      const warehouseCodeList = res.map((item: any) => String(item.resourceCode))
      return request({
        url: `/carrierContractApi/queryWarehouseByErp?warehouseType=${warehouseType}`,
        method: 'post',
        data,
      }).then((res: any) => {
        const list = res.data.filter((item: any) => warehouseCodeList.includes(String(item.warehouseCode)))
        res.data = list
        return res
      })
    })
  }

  return request({
    url: `/carrierContractApi/queryWarehouseByErp?warehouseType=${warehouseType}`,
    method: 'post',
    data,
  })
}
export function getWarehouseList(data: any): Promise<unknown> {
  const shopId = String(data?.shopId || data?.dealerShopId || '').trim()
  const cacheKey = JSON.stringify({
    shopId,
    locale: isToTransfer() ? getCurrentLocaleTransferCode() : 'default',
  })

  const cloneWarehouseResponse = (response: any) => {
    if (!response || typeof response !== 'object')
      return response
    const list = Array.isArray(response.data)
      ? response.data.map((item: any) => ({ ...item }))
      : response.data
    return {
      ...response,
      data: list,
    }
  }

  const now = Date.now()
  const cached = warehouseListResponseCache.get(cacheKey)
  if (cached && cached.expireAt > now)
    return Promise.resolve(cloneWarehouseResponse(cached.response))

  const pendingRequest = warehouseListPendingMap.get(cacheKey)
  if (pendingRequest)
    return pendingRequest.then((res: any) => cloneWarehouseResponse(res))

  const requestPromise = request({
    url: `/dealer-shop-warehouse/query/warehouseList?shopId=${shopId}&dealerShopId=${shopId}`,
    method: 'get',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: 'null',
            transferKeysConfig: JSON.stringify([
              [
                'data',
                'warehouseName',
              ],
              [
                'data',
                'skuInfos',
              ],
            ]),
          }
        : undefined,
    },
  })
    .then((res: any) => {
      warehouseListResponseCache.set(cacheKey, {
        expireAt: Date.now() + WAREHOUSE_LIST_CACHE_TTL,
        response: res,
      })
      return res
    })
    .finally(() => {
      warehouseListPendingMap.delete(cacheKey)
    })

  warehouseListPendingMap.set(cacheKey, requestPromise)
  return requestPromise.then((res: any) => cloneWarehouseResponse(res))
}

export function queryCountryList(data: any): Promise<unknown> {
  return request({
    url: `/dealerShopServiceProduct/queryCountryList?dealerShopId=${data.dealerShopId}`,
    method: 'post',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: 'null',
            transferKeysConfig: JSON.stringify([
              [
                'data',
                'aliasName',
              ],

            ]),
          }
        : undefined,
    },
  })
}

export function queryCargoType(data: any): Promise<unknown> {
  return request({
    url: `/dealerShopServiceProduct/queryCargoType?shopId=${data.shopId}`,
    method: 'post',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: 'null',
            transferKeysConfig: JSON.stringify([
              [
                'data',
                'userDef1',
              ],

            ]),
          }
        : undefined,
    },
  })
}

export function getCalList(data: any): Promise<unknown> {
  return request({
    url: '/dealerShopServiceProduct/calList',
    method: 'post',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: 'null',
            transferKeysConfig: JSON.stringify([
              [
                'data',
                'productName',
              ],
              [
                'data',
                'freightType',
              ],
              [
                'data',
                'carrierList',
              ],

            ]),
          }
        : undefined,
    },
  })
}

export function goodsPostCalList(data: any): Promise<unknown> {
  return request({
    url: `/dealerShopServiceProduct/goodsPostCalList?shopId=${data.shopId}`,
    method: 'post',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            setPath: 'null',
            transferKeysConfig: JSON.stringify([
              [
                'data',
                'productName',
              ],
              [
                'data',
                'freightType',
              ],
              [
                'data',
                'carrierList',
              ],
            ]),
          }
        : undefined,
    },
  })
}

export function queryAllTransportGoodsList(data: any): Promise<unknown> {
  return request({
    url: `/dealerShopServiceProduct/queryAllTransportGoodsList?shopId=${data.shopId}`,
    method: 'post',
    data: {
      ...data,
    },
  })
}

export function queryDealerShopServiceProductById(data: any): Promise<unknown> {
  const query = new URLSearchParams()
  if (data.shopId) {
    query.set('shopId', data.shopId)
  }
  if (data.productId) {
    query.set('productId', data.productId)
  }

  return request({
    url: `/dealerShopServiceProduct/queryById${query.toString() ? `?${query.toString()}` : ''}`,
    method: 'post',
    data: {
      ...data,
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),

            transferType: 'html',
            transferKeysConfig: JSON.stringify([
              [
                'data.productDesc',
              ],

            ]),
          }
        : undefined,
    },
  })
}

// 预报订单(新) 获取仓库
export function getCommonSelectList(data: any): Promise<unknown> {
  return request({
    url: '/dealerShopServiceProduct/querySelectList',
    method: 'post',
    data,
  })
}

// 获取承运商
export function fetchSupplier(): Promise<unknown> {
  return request({
    url: '/admin/carriercontract/queryAllCarrierList',
    method: 'post',
  })
}
// 获取承运商 产品
export function queryCarrierProduct(data?: any): Promise<unknown> {
  return request({
    url: '/admin/carriercontract/queryCarrierProduct',
    method: 'post',
    data,
  })
}
//   打印数据
export function orderPrint(data: any, option: any): Promise<unknown> {
  return request(
    {
      url: '/print/waybill',
      method: 'get',
      data,
      baseURL: BASEURL,
    },
    option,
  )
}

// 获取地址下拉数据(旧的)
export function getAddressListOld(data?: any): Promise<unknown> {
  return request({
    url: '/portal/addressLibrary/getAddressTree',
    method: 'post',
    data,
  })
}
// 获取地址下拉数据(懒加载)
export function getAddressList(data?: any): Promise<unknown> {
  return request({
    url: '/portal/addressLibrary/queryAddressList?transferlocate=true',
    method: 'post',
    data: {
      ...data,
      ___transferConfig: data?.___transferConfig
        ?? (isToTransfer()
          ? {
              language: getCurrentLocaleTransferCode(),
              setPath: 'null',
              transferKeysConfig: JSON.stringify([
                ['data', 'divisionName'],
                ['data', 'aliasName'],
              ]),
            }
          : undefined),
    },
  })
}
// 获取来源下拉数据(懒加载)
export function getCustomerSource(data?: any): Promise<unknown> {
  return request({
    url: '/customerInfo/getCustomerSource',
    method: 'post',
    data,
  })
}

// 获取币种
export function queryCurrencyList(data?: any): Promise<unknown> {
  return request({
    url: '/carrierContractApi/queryCurrencyList',
    method: 'post',
    data,
  })
}

// 获取货物类型  所有
export function queryShopAllCargoTypeList(data?: any): Promise<unknown> {
  return request({
    url: '/dealerShopServiceProduct/queryShopAllCargoTypeList',
    method: 'POST',
    data,
  })
}
// 获取运输方式  所有
export function queryShopAllFreightType(data?: any): Promise<unknown> {
  return request({
    url: '/dealerShopServiceProduct/queryShopAllFreightType',
    method: 'POST',
    data,
  })
}

// 获取包裹状态

export function getNoticesList(data: any): Promise<unknown> {
  return request({
    url: '/admin/manage/notices/noticesList', // 配置url
    method: 'post', // 配置请求方式
    data: {
      ...data,
      pageNo: data.pageNo || 0,
    },
  })
}

// 批量删除包裹
export function batchRemovePackage(data: any): Promise<unknown> {
  return request({
    url: '/member-package/remove', // 配置url
    method: 'post', // 配置请求方式
    data: {
      ...data,

    },
  })
}

// 设置页面配置
export function saveOrUpdatePageConf(
  data: any,
  _options: any,
): Promise<unknown> {
  return request({
    url: '/page/conf/saveOrUpdatePageConf',
    method: 'post',
    data: {
      pageConfig: data.storageConfig,
      name: data.storageListKey,
      id: data.id,
      page: data.storageListKey,
      configType: data.configType || 'LIST',
    },
  })
}
// 获取页面配置
export function queryPageConf(data: any, _options: any): Promise<unknown> {
  return request({
    url: '/page/conf/queryPageConf',
    method: 'post',
    data: {
      name: data.storageListKey,
      page: data.storageListKey,
      configType: data.configType || 'LIST',
    },
  }).then((res: any) => {
    if (res && res.data && res.data[0]) {
      return { configData: res.data[0].pageConfig || '', id: res.data[0].id }
    }
    else {
      return { configData: '', id: '' }
    }
  })
}

export function queryPageConfList(data: any, _options: any): Promise<unknown> {
  return request({
    url: '/page/conf/queryPageConf',
    method: 'post',
    data: {
      name: data.storageListKey,
      page: data.storageListKey,
      configType: data.configType || 'LIST',
    },
  })
}

// 查询尾程物流轨迹
export function queryTrajectoryByTailWaybillNoList(data: any): Promise<unknown> {
  return request({
    url: '/jyUserOrder/queryTrajectoryByTailWaybillNoList', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 领取优惠券
export function manualGetCoupon(data) {
  return request({
    url: '/marketingActivity/manualGetCoupon', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 用户注册
export function H5Regist(data) {
  return request({
    url: '/portal/auth/regist/member', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 邮箱验证码发送
export function sendEmailVerificationCode(data) {
  return request({
    url: '/portal/auth/sendEmailVerificationCode',
    method: 'post',
    data,
  })
}

// 邮箱验证码校验
export function verifyEmailCode(data) {
  return request({
    url: '/portal/auth/verifyEmailCode',
    method: 'post',
    data,
  })
}

// 邮箱注册
export function registMemberWithEmail(data) {
  return request({
    url: '/portal/auth/regist/memberwithemail',
    method: 'post',
    data,
  })
}

// 邮箱验证码登录
export function loginWithEmailVerificationCode(data) {
  return request({
    url: '/portal/auth/loginWithEmailVerificationCode',
    method: 'post',
    data,
  })
}

//  验证会员手机号
export function verifyMemberPhoneExists(data) {
  return request({
    url: '/portal/auth/verifyMemberPhoneExists', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 找回密码 - 重置会员密码
export function resetMemberPassword(data) {
  return request({
    url: '/portal/auth/resetMemberPassword',
    method: 'post',
    data,
  })
}

// 找回密码 - 通过邮箱重置密码
export function restPasswordByEmail(data) {
  return request({
    url: '/portal/auth/restPasswordByEmail',
    method: 'post',
    data,
  })
}

// 批量更新包裹拆包标识
export function batchUpdateUnpackSendMode(data: any): Promise<unknown> {
  return request({
    url: '/member-package/batchUpdate/unpackSendMode',
    method: 'post',
    data,
  })
}

// ERP平台订单货物类型查询
export async function getPlatformOrderCargoType(): Promise<unknown> {
  const StoreInformation: any = localStorage.getItem(
    storeData.StoreInformation,
  )
  const shopInfo: any = JSON.parse(StoreInformation)

  let data: any[] = []
  try {
    const res: any = await request({
      url: '/open/sysArgument/queryArgument',
      method: 'post',
      data: {
        param: {
          argKey: `appOpenArg-${shopInfo.scId}_ERP_PLATFROM_ORDER_CARGO_TYPE_CODE`,
        },
      },
    })
    if (res.data?.argValue) {
      data = JSON.parse(res.data.argValue)
    }
  }
  catch (error) {
    console.error(error)
  }

  if (!data || data?.length === 0) {
    try {
      const res: any = await request({
        url: '/open/sysArgument/queryArgument',
        method: 'post',
        data: {
          param: {
            argKey: `appOpenArg-default_ERP_PLATFROM_ORDER_CARGO_TYPE_CODE`,
          },
        },
      })
      if (res.data?.argValue) {
        data = JSON.parse(res.data.argValue)
      }
    }
    catch (error) {
      console.error(error)
    }
  }

  return {
    data,
  }
}
